import _ from "utilities/vendor/lodash/4.13.1/js/lodash.custom.min";
const Utilities = {
  /**
   * Generates a random hex string to be used for token generation
   * @return {string} random hex string
  */
  uuidString: () => (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1),
};

export default Utilities;
